/**
 * Strip internal / non-user-facing eligibility noise (e.g. lenderId) from pricing UI.
 */

/** True when param key is a lender-id field (any casing, spaces, underscores). */
export function isLenderIdIneligibleParam(param) {
  if (param == null || typeof param !== 'string') return false;
  const n = param.replace(/[\s_]/g, '').toLowerCase();
  return n === 'lenderid';
}

const LENDER_ID_IN_REASON_TEXT = /lender\s*[_ ]?\s*id\b/i;

/** Drop free-text reasons that mention lender id. */
export function filterIneligibleReasonStrings(reasons) {
  if (!Array.isArray(reasons)) return [];
  return reasons.filter((r) => typeof r !== 'string' || !LENDER_ID_IN_REASON_TEXT.test(r));
}

export function filterFailingParamsForDisplay(failingParams) {
  if (!Array.isArray(failingParams)) return [];
  return failingParams.filter((fp) => !isLenderIdIneligibleParam(fp?.param));
}

export function filterExplicitRulesForDisplay(rules) {
  if (!Array.isArray(rules)) return [];
  return rules.filter((r) => typeof r !== 'string' || !LENDER_ID_IN_REASON_TEXT.test(r));
}

/** True if anything remains to show after hiding lender id. */
export function hasDisplayableEligibilityAnalysis(analysis) {
  if (!analysis) return false;
  return (
    filterFailingParamsForDisplay(analysis.failingParams).length > 0 ||
    filterExplicitRulesForDisplay(analysis.explicitRules).length > 0
  );
}
